"use client";
import { Sparkles } from "lucide-react";

export function BrandIntroSection({ lookUpCMSData, homeDetails }: any) {
  return (
    <section className="py-10 md:py-20 bg-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-[#F9F7F4] rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-[#F9F7F4] rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/3" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {lookUpCMSData?.["Home - Section 1 : The Kavish Philosophy"] ? (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  lookUpCMSData?.["Home - Section 1 : The Kavish Philosophy"]
                    ?.Template,
              }}
            />
          ) : (
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 bg-[#F9F7F4] px-6 py-3 rounded-full mb-6">
                <Sparkles className="h-4 w-4 text-[#B42025]" />
                <span className="text-[#B42025] tracking-[0.3em] text-sm uppercase">
                  The Kavish Philosophy
                </span>
              </div>

              <h2 className="text-4xl md:text-6xl mb-8 text-[#1A1A1A] leading-tight">
                More Than Stays.
                <br />
                <span className="text-[#B42025]">Curated Experiences.</span>
              </h2>

              <div className="w-24 h-1 bg-[#C9A962] mx-auto mb-12" />
            </div>
          )}
          <div className="grid md:grid-cols-2 gap-8">
            {homeDetails?.Philosophy?.slice(0, 4)?.map(
              (p: any, index: number) => (
                <div className="bg-[#F9F7F4] p-10 rounded-2xl" key={index}>
                  <div className="text-6xl text-[#B42025] mb-4">
                    {index < 10 && "0"}
                    {index + 1}
                  </div>
                  <div
                    suppressHydrationWarning={true}
                    className="text-gray-700 leading-relaxed"
                    dangerouslySetInnerHTML={{
                      __html: p?.ShortDescription?.trim(),
                    }}
                  />
                </div>
              ),
            )}
          </div>

          {/* <div className="text-center">
            <Button
              className="bg-[#B42025] hover:bg-[#8F1A1E] text-white px-10 shadow-lg hover:shadow-xl transition-all duration-300"
              size="lg"
            >
              Discover The Kavish Philosophy
            </Button>
          </div> */}
        </div>
      </div>
    </section>
  );
}
